import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import FormControl from "@mui/material/FormControl";
import { titleCase } from "../../CommonFuntion/SchemaValidation";

export function Checkbox(props) {
  const { name, label, validation } = props;
  const { setFieldValue, values } = useFormikContext();
  useEffect(() => {
    if (values[name] !== "Y" && values[name] !== "N") {
      setFieldValue(name, "N");
    } else {
      setFieldValue(name, values[name]);
    }
  }, [values[name], name, setFieldValue]);
  const checkChanged = (e) => {
    setFieldValue(name, e.target.checked ? "Y" : "N");
  };
  const id = `${name}-checkbox`;
  return (
    <>
      <div className="flex-container">
        <div className="control-bottom-border">
          {label && (
            <label className="font-css" htmlFor={id}>
              {titleCase(label.replace("_", " "))}
              {validation?.mandatory && (
                <span className="mandatory-validation">{"*"}</span>
              )}
            </label>
          )}
        </div>

        <div className="control-bottom-border">
          <FormControl>
            <input
              type="checkbox"
              id={id}
              name={name}
              onChange={checkChanged}
              checked={values[name] === "Y"}
            />
          </FormControl>
        </div>
      </div>
    </>
  );
}
